var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgToolSearch = function SvgToolSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 15a5 5 0 1 0 0-10 5 5 0 0 0 0 10m0 1a6 6 0 1 0 0-12 6 6 0 0 0 0 12",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.646 13.646a.5.5 0 0 1 .708 0l5.5 5.5a.5.5 0 0 1-.708.708l-5.5-5.5a.5.5 0 0 1 0-.708",
    clipRule: "evenodd"
  })));
};
export default SvgToolSearch;